module.exports = __webpack_public_path__ + "img/vip1.252a44c5.png";